import { useNavigate, useParams } from "react-router";
import { z } from "zod";
import styles from "./DailyOverview.module.scss";
import { Group } from "../Patient/Activities/Group/Group";
import {
  BackButton,
  CloseButton,
} from "@/components/NavigationButtons/NavigationButtons";

export const GroupInDailyOverview = () => {
  const { groupId } = z.object({ groupId: z.string() }).parse(useParams());
  const navigate = useNavigate();

  return (
    <div className={styles.activityOccurrenceOrGroup}>
      <Group
        groupId={groupId}
        closeGroupPanel={() => navigate("..")}
        navigationButtonsInHeader={{
          backButton: <BackButton navigateBack={() => navigate("..")} />,
          closeButton: <CloseButton close={() => navigate("..")} />,
        }}
      />
    </div>
  );
};
